import React, { useState } from 'react'
import { message } from 'antd'
import { cdnImg } from 'meinian-package/src/utils/image'
import moment from 'moment'
import ImageDetail from 'view/detail/imageDetail'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'
import { targetCategory } from 'common'
import styles from './chooseTaskStyle.module.less'

const CardImage = ({
  itemData,
  columnWidth,
  infoHeight = 24,
  total,
  data,
  action,
  ...props }) => {
  const [lastRouter] = useState(location.pathname + location.search)
  const [visible, setVisible] = useState(false)

  const {
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    targetInfo,
    collectTime,
    collectId,
    targetId,
    collectUserName,
    blogDeleted,
  } = itemData || {}

  const remote = () => {
    ModalConfirm.show({
      title: '确认移除',
      content: '是否移除当前关联任务',
      onOk: async () => {
        request.post('/zhikuan/ins/blog/mission/blog-cancel-related-target', { collectId, targetIdList: [targetId] }).then(success => {
          if (success) {
            message.success('成功移除!')
            props.initSubColls && props.initSubColls()
            action.onDelete([imageGroupEntityId, inspirationId])
            props.onResize()
          }
        })
      },
    })
  }

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
    }
  }
  return <div
    className={styles.mnChooseTaskCard}
    style={{
      width: columnWidth,
      height: Math.round((columnWidth * props.height) / props.width) + infoHeight,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <div
      className={styles.mnChooseTaskCardImageWrap}
      onClick={() => {
        if (blogDeleted !== 1) {
          history.replaceState({}, '', `/meinian/detail/image?imageGroupEntityId=${imageGroupEntityId}&inspirationId=${inspirationId}&collectId=${collectId}`)
          setVisible(true)
        } else {
          message.info('款式已不存在')
        }
      }}
    >
      <img className={styles.mnChooseTaskCardImage} src={cdnImg(mainUrl, 500)} />
      <div
        className={styles.mnChooseTaskCardMask}
        onClick={(e) => {
          e.stopPropagation()
          remote()
        }}
      >
        <div className={styles.mnChooseTaskCardRemoteTask}>从任务中移除</div>
      </div>
      {
          blogDeleted === 1 && <div className={styles.mnChooseTaskCardImageWrapStatus}>已删除</div>
        }
    </div>
    <div className={styles.mnChooseTaskCardFooter}>
      <div className={styles.mnChooseTaskCardFooterLeft}>
        {moment(collectTime).format('YYYY/MM/DD')}
        <span className={styles.mnChooseTaskCardFooterUser}>
          <div className={styles.mnChooseTaskCardFooterUserName}>{collectUserName}</div>
          采集
        </span>
      </div>
      <div className={styles.mnChooseTaskCardFooterLabel}>{
        targetCategory(
          targetInfo?.gender,
          targetInfo?.rootCategory,
          targetInfo?.category
        )
  }</div>
    </div>
    {visible ? <ImageDetail
      list={data}
      maxListLength={total || data.length}
      onChangeIndex={props.onChangeIndex}
      visible={visible}
      onChange={_onChange}
      onVisibleChange={(_visible) => {
        history.replaceState({}, '', lastRouter)
        setVisible(_visible)
      }}
      onDeleteItem={(record) => {
        action.onDelete([record.imageGroupEntityId, record.inspirationId])
        props.onResize()
      }}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}

export default CardImage
